// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/compliance/v1/compliance.proto (package stailer_service_specification.compliance.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");
const { file_stailer_service_specification_compliance_legal_terms_v1_legal_terms } = require("../legal_terms/v1/legal_terms_pb");

/**
 * Describes the file stailer_service_specification/compliance/v1/compliance.proto.
 */
const file_stailer_service_specification_compliance_v1_compliance = /*@__PURE__*/
  fileDesc("CjxzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jb21wbGlhbmNlL3YxL2NvbXBsaWFuY2UucHJvdG8SK3N0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLmNvbXBsaWFuY2UudjEipQIKCkNvbXBsaWFuY2US/gEKE3NlcnZpY2VfcmVndWxhdGlvbnMYBSADKAsySi5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jb21wbGlhbmNlLmxlZ2FsX3Rlcm1zLnYxLlNlcnZpY2VSZWd1bGF0aW9uQpQBkoIZbOOBneOBruS7luOCv+ODluOBruOAjOOBk+OBruOCteODvOODk+OCueOBq+OBpOOBhOOBpuOAjeOBp+ODkeODvOODiOODiuODvOOBlOOBqOOBq+ihqOekuuOBmeOCi+mgheebruOBp+OBmeOAgqqCGRjjgrXjg7zjg5Pjgrnopo/lrprpoIXnm664ghkCwIIZAUoECAEQAkoECAIQA0oECAMQBEoECAQQBWIGcHJvdG8z", [file_description_support_v1_field_description, file_stailer_service_specification_compliance_legal_terms_v1_legal_terms]);

/**
 * Describes the message stailer_service_specification.compliance.v1.Compliance.
 * Use `create(ComplianceSchema)` to create a new message.
 */
const ComplianceSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_compliance_v1_compliance, 0);


exports.file_stailer_service_specification_compliance_v1_compliance = file_stailer_service_specification_compliance_v1_compliance;
exports.ComplianceSchema = ComplianceSchema;
